import React, { useMemo } from 'react';
import { Select } from 'antd';
import { DateTime } from 'luxon';

import DisplayText from '../common/text/DisplayText';

import { getRepeatText } from '../helpers/time';

export default function ScheduleDateRepeatSelector({
  startTime,
  value: repeatMode = null,
  onChange,
  isDisplay,
  isTemplate,
  timezone,
  allowBiweekly,
}) {
  const startDT = useMemo(() => (
    startTime
      ? DateTime.fromMillis(startTime, { zone: timezone })
      : DateTime.local()
  ), [startTime, timezone]);

  const options = useMemo(() => {
    const opts = [
      { label: getRepeatText({ mode: null, datetime: startDT, isTemplate}), value: null },
      { label: getRepeatText({ mode: 'daily', datetime:  startDT, isTemplate}), value: 'daily' },
      { label: getRepeatText({ mode: 'weekly', datetime:  startDT, isTemplate}), value: 'weekly' },
      { label: getRepeatText({ mode: 'biweekly', datetime:  startDT, isTemplate}), value: 'biweekly' },
      { label: getRepeatText({ mode: 'monthlyNumber', datetime:  startDT, isTemplate}), value: 'monthlyNumber' },
      { label: getRepeatText({ mode: 'monthlyDay', datetime:  startDT, isTemplate}), value: 'monthlyDay' },
      { label: getRepeatText({ mode: 'weekdays', datetime:  startDT, isTemplate}), value: 'weekdays' },
      { label: getRepeatText({ mode: 'annually', datetime:  startDT, isTemplate}), value: 'annually' },
    ];
    if (allowBiweekly) return opts;
    return opts.filter((opt) => opt.value !== 'biweekly');
  }, [startDT, isTemplate, allowBiweekly]);

  return (
    <div>
      <div style={{ marginBottom: 5, fontWeight: 500 }}>
        Repeat
      </div>
      {isDisplay ? (
        <DisplayText
          title={getRepeatText({ mode: repeatMode, datetime: startDT })}
        />
      ) : (
        <Select
          value={repeatMode}
          onSelect={onChange}
          style={{ width: 200 }}
          options={options}
        />
      )}
    </div>
  );
}
